<template>

    <!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
                    <router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getRange()"> Tessere </a> 
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> Range</span>
                </h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
            </div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
   
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-on:click="newCardRange()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<div><Translate :path="'dizionario.base.BTN_NUOVO'"></Translate> Range</div> 
							</div>
							<div class="text-success fw-semibold">Aggiungi</div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(48)" title="Opzioni Card" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(48)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(48)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
	                </div>
	            </div>
	        </div> 
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#ranges-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-menu7"></i>
								<span class="hidden-lg ms-1">Range</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Range</span>
    						</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#range-b" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1" v-on:click="openRangeTessere(0);">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-activity"></i>	
								<span class="hidden-lg ms-1">Tessere</span>
								<span class="hidden-xs ms-1">Gestione Tessere</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>  

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
						</li>
						<li class="nav-item ms-3">
	                        <select class="form-select form-select-sm changeyear" id="comboAnno" @change="getCardsRange()" v-model="FK_ID_SEASON" :tabindex="4">
	                            <option v-for="stagione in arrayStagioni" v-bind:value="stagione.ID_SEASON" v-bind:key="stagione.ID_SEASON">{{stagione.DESCRIZIONE}}</option>
	                        </select>
						</li>
					</ul>
			   </div>
			</div>
		</div>
		<!-- /profile navigation -->	

    </div>
    <!-- /page header -->

    <!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="ranges-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse show" id="collapse-all" style="">				
		                <div class="card-body pb-0">
		                    <div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="range-a">
									<div class="row ">
										<div class="col-4 col-md-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Id stagione" v-model="search.ID_RANGE.VALUE" :tabindex="1" />
										</div>	
										<div class="col-8 col-md-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Descrizione" v-model="search.DENOMINAZIONE.VALUE" :tabindex="1" />
										</div>               
										<div class="col-md-7 mbx-1">
		
										</div>              
										<div class="col-6 col-md-1 col-lg-1">
											<select class="form-select form-select-sm" data-placeholder="Stato" v-model="search.FLG_ATTIVO.VALUE" :tabindex="7">
												<option value="">Stato </option>   
												<option value="1"> &nbsp; Attivate</option>
												<option value="0"> &nbsp; Disattivate</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a href="#collapse-a" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
												&nbsp;
											</a>
										</div>  
									</div>
								</form>
							</div> 
						</div>
					</div>
		
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
								<thead class="sticky-top">
									<tr class="bg-secondary text-white">
										<!--<th class="table-head-sm" rowspan="2" style="width:2%;"> <input id="chkAllCategorie" v-on:click="filters.selectAll('chkAllCategorie',paginatedList.arr)" type="checkbox" class=""> </th>-->
										<th class="table-head-sm" rowspan="2" style="width:6%;"> #</th>
										<th class="table-head-sm" rowspan="2" style="width:30%;">Ente / Ragione Sociale</th>
										<th class="table-head-sm text-center" rowspan="2" style="width:9%;">Numerazione<br>Da / A</th>
										<th class="table-head-sm text-center" style="width:7%;">Raspa Emesse<br><span class="badge bg-light badge-xs text-dark rounded-5">{{ getTotali("TOT_RANGE_EMESSE") }}</span></th>
										<th class="table-head-sm text-center" style="width:7%;">Raspa Usate<br><span class="badge bg-light badge-xs text-dark rounded-5">{{ getTotali("TOT_RANGE_ASSEGNATE") }}</span></th>
										<th class="table-head-sm text-center" rowspan="2" style="width:5%;">Tipo</th>
										<th class="table-head-sm text-center" style="width:7%;">Generiche Wtp<br><span class="badge bg-light badge-xs text-dark rounded-5">{{ getTotali("TOT_RANGE_WTP") }}</span></th>
										<th class="table-head-sm text-center" style="width:7%;">Generiche GoSki<br><span class="badge bg-light badge-xs text-dark rounded-5">{{ getTotali("TOT_RANGE_GOSKIPASS") }}</span></th>
										<th class="table-head-sm text-center" rowspan="2" style="width:5%;">Stato</th>
										<th class="table-head-sm" rowspan="2" style="width:5.4%;">Azioni</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="range in paginatedList.arr" v-bind:key="range.ID_RANGE">
										<!--
										<td class="td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="range.SELEZIONATO" class=""> 
										</td>
										-->
										<td class="td-class fs-sm">
											<span>{{range.ID_RANGE}}</span>
											<small class="badge bg-light badge-xs text-primary cursor-pointer float-end"> {{range.ORDINE}} </small>
										</td>
										<td class="td-class fs-sm"> 
											<span class="text-primary fw-bold cursor-pointer" v-on:click="editCardRange(range)">{{range.FK_ID_AZIENDA}} {{range.DENOMINAZIONE}} </span><br />	                                   
											<span class="text-muted">Metti in Evidenza</span> 
										</td>
										<td class="td-class fs-sm">
											<div><i class="ph-check-circle fs-base lh-base align-top text-success me-1"></i> Da: <span class="text-primary">{{ range.CARD_RANGE_START }}</span></div>
											<div><i class="ph-check-circle fs-base lh-base align-top text-danger me-1"></i> A:&nbsp;&nbsp; <span class="text-primary">{{ range.CARD_RANGE_END }}</span></div>
										</td>	
										<td class="td-class fs-sm text-center"><span> {{ range.TOT_RANGE_EMESSE }} </span></td>
										<td class="td-class fs-sm text-center">{{ range.TOT_RANGE_ASSEGNATE }} </td>
										<td class="td-class fs-sm text-center"> {{ range.CARD_RANGE_TYPE == '2' ? 'CARTACEO' : 'ONLINE' }} </td>
										<td class="td-class fs-sm text-center"><span>{{ range.TOT_RANGE_WTP }}</span></td>
										<td class="td-class fs-sm text-center"><span>{{ range.TOT_RANGE_GOSKIPASS }}</span></td>
										<td class="td-class fs-sm text-center">
											<ISwitch @toggle="updateStatoCardRange(range)" v-model="range.FLG_ATTIVO" :size="'sm'" style="z-index: 0;"></ISwitch>
										</td>
										<td class="td-class text-center">
											<div class="dropdown">
	                                            <a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
	                                                <i class="ph-list"></i>
	                                            </a>
	                                            <div class="dropdown-menu dropdown-menu-end">
													<a href="#" class="dropdown-item" v-on:click="editCardRange(range)"><i class="fad fa-pencil fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Range</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-on:click="openRangeTessere(range.ID_RANGE)"><i class="fad fa-cogs fa-fw me-2"></i><span class="text-muted me-1">|</span>Gestione Range</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-on:click="deleteRange(range)"><i class="fad fa-trash fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina Tessera</a>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
					            <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">TOT. RANGE: {{ paginatedList.count }}</span> 
					            </div>
					        </div>
							<div class="col-9 col-md-6" :tabindex="27">
								<div class="float-end pag-mobile">
			                            <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
								</div>
							</div>
					        <div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
									<option value="5">5</option>
									<option value="10">10</option>
									<option value="25">25</option>
									<option value="50">50</option>
									<option value="75">75</option>
									<option value="100">100</option>
									<option value="250">250</option>
									<option value="500">500</option>
								</select>
							</div>
						</div>	
					</div>	
				</div>
			</div>	 

		</div>		
	</div>


	<!-- START MODALI -->
    <div class="modal fade" id="popUpCardRange" role="dialog" tabindex="-1">
	    <div class="modal-dialog">
	        <div class="modal-content">
	            <div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">AGGIUNGI RANGE TESSERE</h5>
					<button type="button" class="btn-close text-white" data-bs-dismiss="modal">X</button>
	            </div>
				<div class="modal-body" style="height: 250px">

					<div class="row mb-2">
						<div class="col-md-12">
							<label>Ente</label>
							<Select2 :disabled="rangeSelezionato.ID_RANGE > 0" v-model="rangeSelezionato.FK_ID_AZIENDA" :w="250" :api="'travel/s2/agenzie'" :apiselected="'travel/s2/agenzia'" ::tabindex="2"></Select2>
						</div>
					</div>

					<div class="row mb-2">
						<div class="col-md-6" v-show="rangeSelezionato.ID_RANGE == 0">
							<label>Stagione</label>
							<select class="form-select form-select-sm changeyear"  v-model="rangeSelezionato.FK_ID_SEASON" :tabindex="4">
								<option v-for="stagione in arrayStagioni" v-bind:value="stagione.ID_SEASON" v-bind:key="stagione.ID_SEASON">{{stagione.DESCRIZIONE}}</option>
							</select>
						</div>	
						<div class="col-md-6">
							<label>Tipo range</label>
							<select class="form-select form-select-sm" id="card_range_type" v-model="rangeSelezionato.CARD_RANGE_TYPE">
								<option value="1" >Online</option>
								<option value="2">Cartaceo</option>
							</select>
						</div>
					</div>

					<div class="row mb-2">
						<div class="col-md-6">
							<label>Numero tessera start</label>
							<input class="form-control" type="number" v-model="rangeSelezionato.CARD_RANGE_START">
						</div>
						<div class="col-md-6">
							<label>Numero tessera end</label>
							<input class="form-control" type="number" v-model="rangeSelezionato.CARD_RANGE_END">
						</div>
					</div>            

                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw me-1"></i> CHIUDI </button>
                    <button type="button" class="btn btn-secondary float-end" v-on:click="saveCardRange()"><i class="fal fa-save fa-fw me-1"></i> Salva Modifiche </button>                                   
                </div>                
            </div>
        </div>
    </div>

	
</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import Select2 from '@/components/utils/Select2.vue'
//import ISort from '@/components/utils/ISort.vue'

export default {
    name:"CardsRange",	 

    components:{
        Pagine,
        ISwitch,	
		Select2,
		//ISort,
    },

    data: function (){
      	return{
            apiStartup:'raspa/range',
	        filters:global.filters,	
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            rangeSelezionato:new Array(),
			FK_ID_SEASON:0,
	        search:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                ID_RANGE:{TYPE:'TEXT',VALUE:''},
				DENOMINAZIONE:{TYPE:'TEXT',VALUE:''},
				FLG_ATTIVO:{TYPE:'COMBO',VALUE:'1'},
 
			},
			rs : utils.generateRandomString(30),
			arrayStagioni:new Array(),
			arrayRange:new Array()

      	}
		
    },

    methods: {
        getCardsRange: function () {
            utils.ajax(this.apiStartup,{FK_ID_SEASON:this.FK_ID_SEASON}, (response) => {
                this.arrayRange = response.data;
            }); 
        },

        openCardRange : function(range){
            this.$root.rangeSelezionato = utils.clone(range);
            global.router.push("CardRange");
        },

        newCardRange : function(){ 
			this.rangeSelezionato = {ID_RANGE:0,FLG_ATTIVO:1};
            this.filters.openPopUp("popUpCardRange");  
        },

        editCardRange : function(range){
            this.rangeSelezionato = utils.clone(range);
            this.filters.openPopUp("popUpCardRange");  
        },

        saveCardRange : function(){
            var api = this.rangeSelezionato.ID_RANGE > 0 ? "raspa/range/update" : "raspa/range/insert";
            utils.ajax(api,this.rangeSelezionato, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.filters.closePopUp("popUpCardRange"); 
					this.getCardsRange();
                }
            });
        },

        updateStatoCardRange : function(range){
            setTimeout(() => {
                utils.ajax('raspa/range/update',range, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
                    }  
                }); 
            },250);
        },

		getTotali : function(prop){
			var arr = utils.filter(this.arrayRange,this.search);
			var tot = 0;
			for (var i = 0 ; i < arr.length ; i++){
				tot += parseFloat(arr[i][prop]);
			}
			return tot;
		},

		openRangeTessere : function(idRange){
			this.$root.appoggio.ID_RANGE = idRange;
			this.$root.appoggio.FK_ID_SEASON = this.FK_ID_SEASON;
			global.router.push("CardsRangeTessere");
		}

        
    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayRange,this.search);
            return arr;
        },

       

    },

	watch:{

	},

    created: function () {
		utils.ajax('raspa/range/startup',{}, (response) => {
			this.arrayRange = response.data.RANGE;
			this.arrayStagioni = response.data.SEASON;
			for (var i = 0 ; i < this.arrayStagioni.length ; i++){
				if (this.arrayStagioni[i].FLG_CURRENT_SEASON == 1){
					this.FK_ID_SEASON = this.arrayStagioni[i].ID_SEASON;
					break;
				}
			}
		}); 		
    }

}
</script>